import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Alert, Box, Chip, IconButton, Paper, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import * as GeoAdConstants from './GeoAdConstants.js';
import ETVPage from '../tools/ETVPage.js';
import ETVPopup from '../tools/ETVPopup.js';
import ETVMessagePopup from '../tools/ETVMessagePopup.js';
import ETVActionButton from '../tools/ETVActionButton.js';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

class GeoAdBookings extends React.Component {

	constructor(props) {
      	super(props);
		this.closeInfoMessage = this.closeInfoMessage.bind(this);
    }

    state = {
      	isLoaded: false,
		isLoading: false,
		locations:[],
		selected_location_id:'',
		slots:[],
		cur_slot:{},
		monthDate:this.startOfMonth(new Date()),
		window:'',
    }

    componentDidMount() {
		this.loadLocations();
    }

	componentDidUpdate() {
		if(this.state.isLoading) {
			return;
		}
		if(!this.state.isLoaded) {
			this.loadLocations();
		}
	}

	getGeoAdHeaders() {
		return {
			'user_id': localStorage.getItem("etv.user_id"),
			'access_token': localStorage.getItem("etv.access_token"),
		};
	}

    loadLocations() {
		this.setState({isLoading:true});
		fetch(GeoAdConstants.GEOAD_BACKEND+"?action=get_locations",{ headers: this.getGeoAdHeaders() })
			.then(res => res.json())
			.then((result) => {
				if(result.result) {
					var locations = result.locations || [];
					var selectedLocationID = locations.length>0?String(locations[0].location_id):'';
					this.setState({
						locations: locations,
						selected_location_id:selectedLocationID,
						isLoaded: true,
						isLoading:false,
					});
					if(selectedLocationID) {
						this.loadData(selectedLocationID);
					}
				}else{
					this.setState({
						isLoaded: true,
						isLoading:false,
					});
					this.showErrorMessage("GeoAd calendar", result.error || "Could not load bookings.");
				}
			})
			.catch((error) => {
				this.setState({
					isLoaded: true,
					isLoading:false,
					error
				});
				this.showErrorMessage("GeoAd calendar", error.message || "Could not load bookings.");
			});
    }

    loadData(locationID) {
		if(!locationID) {
			this.setState({slots:[]});
			return;
		}
		this.setState({isLoading:true});
		fetch(GeoAdConstants.GEOAD_BACKEND+"?action=get_calendar_bookings&location_id="+locationID,{ headers: this.getGeoAdHeaders() })
			.then(res => res.json())
			.then((result) => {
				if(result.result) {
					this.setState({
						slots: result.slots || [],
						isLoaded: true,
						isLoading:false,
					});
				}else{
					this.setState({
						isLoaded: true,
						isLoading:false,
						slots:[],
					});
					this.showErrorMessage("GeoAd calendar", result.error || "Could not load bookings.");
				}
			})
			.catch((error) => {
				this.setState({
					isLoaded: true,
					isLoading:false,
					slots:[],
					error
				});
				this.showErrorMessage("GeoAd calendar", error.message || "Could not load bookings.");
			});
    }

	changeLocation(locationID) {
		this.setState({selected_location_id:locationID,slots:[]});
		this.loadData(locationID);
	}

	showErrorMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
	}

  	closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false});
  	}

	startOfMonth(date) {
		return new Date(date.getFullYear(), date.getMonth(), 1);
	}

	addMonths(date, count) {
		return new Date(date.getFullYear(), date.getMonth() + count, 1);
	}

	formatDateKey(date) {
		var year = date.getFullYear();
		var month = String(date.getMonth()+1).padStart(2,'0');
		var day = String(date.getDate()).padStart(2,'0');
		return year+"-"+month+"-"+day;
	}

	monthLabel(date) {
		return date.toLocaleDateString(undefined, {month:'long', year:'numeric'});
	}

	buildCalendarDays() {
		var first = this.state.monthDate;
		var start = new Date(first);
		var weekday = start.getDay();
		var offset = weekday===0?6:weekday-1;
		start.setDate(start.getDate()-offset);
		var days = [];
		for(var i=0; i<42; i++) {
			var day = new Date(start);
			day.setDate(start.getDate()+i);
			days.push(day);
		}
		return days;
	}

	slotsByDate() {
		return this.state.slots.reduce((result, slot) => {
			var key = String(slot.slot_date || '').slice(0,10);
			if(!result[key]) result[key] = [];
			result[key].push(slot);
			return result;
		}, {});
	}

	levelsForDay(slots) {
		var order = ['MORNING_PEAK','LUNCH_PEAK','DAYTIME_FLOW','EVENING_PEAK','OFF_PEAK'];
		var statusOrder = {RESERVED:1, BOOKED:2};
		return [...slots].sort((a,b) => {
			var levelDiff = order.indexOf(a.level) - order.indexOf(b.level);
			if(levelDiff!==0) return levelDiff;
			return (statusOrder[this.bookingState(a.status)] || 9) - (statusOrder[this.bookingState(b.status)] || 9);
		});
	}

	levelColor(level) {
		if(level==="MORNING_PEAK") return 'error';
		if(level==="LUNCH_PEAK") return 'warning';
		if(level==="DAYTIME_FLOW") return 'info';
		if(level==="EVENING_PEAK") return 'secondary';
		if(level==="OFF_PEAK") return 'success';
		return 'default';
	}

	levelLabel(level) {
		if(level==="MORNING_PEAK") return 'Morning peak';
		if(level==="LUNCH_PEAK") return 'Lunch peak';
		if(level==="DAYTIME_FLOW") return 'Daytime flow';
		if(level==="EVENING_PEAK") return 'Evening peak';
		if(level==="OFF_PEAK") return 'Off-peak';
		return level || 'Traffic';
	}

	statusLabel(status) {
		var labels = {
			SUBMITTED:'Pending approval',
			PENDING_APPROVAL:'Pending approval',
			APPROVED:'Approved',
			PAYMENT_PENDING:'Ready for payment',
			PAID:'Paid',
			LIVE:'Live',
		};
		return labels[status] || status;
	}

	bookingState(status) {
		var value = String(status || '').toUpperCase();
		if(value==="PAID" || value==="LIVE") return "BOOKED";
		return "RESERVED";
	}

	bookingStateLabel(status) {
		return this.bookingState(status)==="BOOKED" ? "Booked" : "Reserved";
	}

	renderCreativePreview(slot) {
		var previewUrl = slot.thumbnail_url || slot.file_url;
		if(!previewUrl) {
			return <Box height={180} display="flex" alignItems="center" justifyContent="center" bgcolor="grey.100">{slot.media_type || 'Creative'}</Box>;
		}
		if(slot.media_type==="VIDEO") {
			return <video src={slot.file_url} controls style={{width:'100%',maxHeight:260,borderRadius:8,background:'#f1f5f9'}} />;
		}
		return <img src={previewUrl} alt={slot.creative_name || 'Creative'} style={{width:'100%',maxHeight:260,objectFit:'contain',borderRadius:8,background:'#f1f5f9'}} />;
	}

	showSlotInfo(slot) {
		this.setState({cur_slot:slot,window:'slot_info'});
	}

	renderLevelChip(slot) {
		var level = slot.level;
		var booked = this.bookingState(slot.status)==="BOOKED";
		return (
			<Box
				key={`${slot.booking_id}-${slot.level}-${slot.status}`}
				onClick={()=>this.showSlotInfo(slot)}
				sx={{
					border:'1px solid #d7e4df',
					borderLeft:'4px solid',
					borderLeftColor:{
						MORNING_PEAK:'#ef4444',
						LUNCH_PEAK:'#f97316',
						DAYTIME_FLOW:'#3b82f6',
						EVENING_PEAK:'#9333ea',
						OFF_PEAK:'#22c55e',
					}[level] || '#64748b',
					borderRadius:'6px',
					padding:'7px 8px',
					background:booked?'#ecfeff':'#fff7ed',
					cursor:'pointer',
				}}
			>
				<Typography variant="caption" fontWeight={800} display="block">{this.levelLabel(level)}</Typography>
				<Typography variant="caption" color={booked?'#0f766e':'#c2410c'} fontWeight={700} display="block">{this.bookingStateLabel(slot.status)}</Typography>
			</Box>
		);
	}

	renderCalendar() {
		var days = this.buildCalendarDays();
		var grouped = this.slotsByDate();
		return (
			<Paper variant="outlined" sx={{overflowX:'auto'}}>
				<Box sx={{display:'grid',gridTemplateColumns:'repeat(7, minmax(150px, 1fr))',borderBottom:'1px solid #d7e4df'}}>
					{WEEKDAYS.map((day) => (
						<Box key={day} sx={{padding:'10px 12px',fontWeight:700,color:'#334155'}}>{day}</Box>
					))}
				</Box>
				<Box sx={{display:'grid',gridTemplateColumns:'repeat(7, minmax(150px, 1fr))'}}>
					{days.map((day) => {
						var key = this.formatDateKey(day);
						var inMonth = day.getMonth()===this.state.monthDate.getMonth();
						var slots = grouped[key] || [];
						return (
							<Box
								key={key}
								sx={{
									minHeight:150,
									padding:1,
									borderRight:'1px solid #d7e4df',
									borderBottom:'1px solid #d7e4df',
									background:inMonth?'#fbfefd':'#f8fafc',
									opacity:inMonth?1:0.52,
								}}
							>
								<Typography variant="body2" fontWeight={700} color="text.secondary">{day.getDate()}</Typography>
								<Stack spacing={0.75} mt={1}>
									{this.levelsForDay(slots).map((slot) => this.renderLevelChip(slot))}
								</Stack>
							</Box>
						);
					})}
				</Box>
			</Paper>
		);
	}

    render() {
      	return(
			<ETVPage width="wide" icon={<CalendarMonthOutlinedIcon fontSize="large"/>} title="Boostly booking calendar"
				description="Reserved and booked ad slots for the selected building." loading={this.state.isLoading}>
				<Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={2}>
						<Select
							size="small"
							value={this.state.selected_location_id}
							displayEmpty
							onChange={(event)=>this.changeLocation(event.target.value)}
							sx={{minWidth:240}}
						>
							<MenuItem value="" disabled>Select building</MenuItem>
							{this.state.locations.map((location) => (
								<MenuItem key={location.location_id} value={String(location.location_id)}>{location.name}</MenuItem>
							))}
						</Select>
						<IconButton onClick={()=>this.setState({monthDate:this.addMonths(this.state.monthDate,-1)})}>
							<ChevronLeft />
						</IconButton>
						<Typography variant="subtitle1" fontWeight={700} minWidth={150} textAlign="center">{this.monthLabel(this.state.monthDate)}</Typography>
						<IconButton onClick={()=>this.setState({monthDate:this.addMonths(this.state.monthDate,1)})}>
							<ChevronRight />
						</IconButton>
				</Box>

				<Box display="flex" gap={1} flexWrap="wrap" mb={2}>
					<Chip size="small" color="error" label="Morning peak" variant="outlined" />
					<Chip size="small" color="warning" label="Lunch peak" variant="outlined" />
					<Chip size="small" color="info" label="Daytime flow" variant="outlined" />
					<Chip size="small" color="secondary" label="Evening peak" variant="outlined" />
					<Chip size="small" color="success" label="Off-peak" variant="outlined" />
					<Chip size="small" sx={{borderColor:'#c2410c', color:'#c2410c'}} label="Reserved" variant="outlined" />
					<Chip size="small" sx={{borderColor:'#0f766e', color:'#0f766e'}} label="Booked" variant="outlined" />
				</Box>

				{this.state.locations.length===0 ? (
					<Alert severity="info">No buildings are available.</Alert>
				) : this.state.slots.length===0 ? (
					<Alert severity="info">No reserved or booked Boostly slots are visible for this building.</Alert>
				) : this.renderCalendar()}

				<ETVPopup
					open={this.state.window==='slot_info'}
					width="small" onClose={()=>this.setState({window:''})} icon={<CalendarMonthOutlinedIcon/>}
					title={`${this.bookingStateLabel(this.state.cur_slot.status)} slot`}
					description="Review the creative, advertiser, schedule, and booking status."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.setState({window:''})}/> }>
						<Box mb={2}>
							{this.renderCreativePreview(this.state.cur_slot)}
						</Box>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell>Building</TableCell>
									<TableCell>{this.state.cur_slot.location_name}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Date</TableCell>
									<TableCell>{String(this.state.cur_slot.slot_date || '').slice(0,10)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Time</TableCell>
									<TableCell>{String(this.state.cur_slot.start_time || '').slice(0,5)} until {String(this.state.cur_slot.end_time || '').slice(0,5)}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Timeslots</TableCell>
									<TableCell>{this.state.cur_slot.slot_count || 1}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Peak</TableCell>
									<TableCell><Chip size="small" color={this.levelColor(this.state.cur_slot.level)} label={this.levelLabel(this.state.cur_slot.level)} /></TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Advertiser</TableCell>
									<TableCell>{this.state.cur_slot.advertiser_email || this.state.cur_slot.advertiser_user_id || this.state.cur_slot.advertiser_company}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Status</TableCell>
									<TableCell>{this.statusLabel(this.state.cur_slot.status)}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
				</ETVPopup>

				<ETVMessagePopup open={this.state.window==='message_div'} type={this.state.spinning?'progress':this.state.info_type} allowClose={!this.state.spinning} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message}/>
			</ETVPage>);
	}
}

export default GeoAdBookings
